module.exports = __webpack_public_path__ + "img/electroniccertificate.5e3ff5f8.png";